import { render } from "./BasicMultipleSelect.vue?vue&type=template&id=4bc57c7e"
import script from "./BasicMultipleSelect.vue?vue&type=script&lang=ts"
export * from "./BasicMultipleSelect.vue?vue&type=script&lang=ts"
script.render = render

export default script